const AgentLoader = ({length=3}) => {
    return (
            <div className="loading_agent_cont">
                {Array.from({ length: length }).map((_, index) => (
                    <div className="loading_agent_links fade-in" key={index}></div>
                ))}
                <div className="loading_agent_textarea">

                </div>
            </div>
    )
}

export default AgentLoader